module.exports = __webpack_public_path__ + "img/BW.c604a977.png";